module.exports = __webpack_public_path__ + "static/media/nra.06038cd1.mp3";